(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('oppROPItemsOverMax', oppROPItemsOverMax);
	oppROPItemsOverMax.$inject = ['$scope', '$timeout', '$rootScope', '$location', '$state',
		'redirectParamsService', 'leanFilterService', 'tableRenderService', 'tableService', 'storeService', 'columnsService', 'flexColumns'];

	function oppROPItemsOverMax($scope, $timeout, $rootScope, $location, $state,
			redirectParamsService, leanFilterService, tableRenderService, tableService, storeService, columnsService, flexColumns) {
		var vm = this;
		var unsubscribe;

		//Report specific variables used in rendering. In this case, for the itemCode renderer a multiFactory field is necessary
		var rendererParams = {
			multiFactory: true,
			specificTaskType: 'task'
		};

		//Directs reportSettings call
		var reportSettingsName = 'reorder-point-items-over-max';

		//You'll need to add these fields in every report since they likely don't already exist.
		var defaultFilters = [];

		var columnList = columns();

		//You should not have to change these lines from report to report
		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		// Extra query params to send to backend in data requests
		var extraParams = [
			{ excelReportName: 'Opportunity' },
			{ name: 'reportRule', value: 'ropItemsOverMax' }
		];


		//In most converted reports $scope.filterService is set to leanFilterService to follow old behavior.
		//This is not necessary, but rather an artifact from the old framework. Remove this setting where you can and in the future
		//make function calls directly through leanFilterService.
		$scope.filterService = leanFilterService;

		vm.showExcel = true; // Determines if excel export button should be displayed

		init(); //Sets all filters. Important to call early in the function so that values are set properly. We had bugs when this was called too late.


		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;
		vm.reportTitle = 'Purchased Inventory Opportunities';
		vm.reportName = 'Reorder point items over max';


		//Sends signal to directive to call exportToExcel function. Defined here because only controller can define
		//function for excel button because it is created by lean-grid. It would also generally be wasteful to define
		//export to Excel functions for each report, since most of them follow the same behavior.
		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', { columns: getExcelColumns(), doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined });
		}



		function getMeta() {
			return meta;
		}


		//Called by directive through & property. Returns response array that has two entries. response[0] contains many
		//important parameters, most notably the data field which is itself an array containing each row.
		//In this case it is also expected to have fields for delivery periods, different reports expect different extra params.
		//response[1] contains a field called total that corresponds to the total amount of rows returned.
		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, columns()).then(function (response) {
				// If any data manipulation is needed, do it here. Most of the time this is unnecessary, but there are special cases
				//that need the response object to be changed. An example seen in purchaseOrders is below.
				return response;
			});
		}


		//Sets all filters and initial values. Also clears filters to avoid bug where leanFilterService would remember
		//old filters when users navigated from report to report.
		function init() {
			$scope.filterService.clearFilters();
			var filters = {};
			if (globalConfig.user.role !== 'Supplier') {
				leanFilterService.useFactoryFilter = true;
				defaultFilters = [
					{
						id: 'factory',
						values: [globalConfig.factory.id]
						, 'isMandatory': true
					},
					{
						id: 'itemGroupNdx',
						values: [$scope.filterService.leanDnaAllSelected]
					},
					{
						id: 'supplierNdx',
						values: [$scope.filterService.leanDnaAllSelected]
					},
					{
						id: 'buyerCode',
						values: [$scope.filterService.leanDnaAllSelected]
					}
				];
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.type = 'multiselect';
				siteFilter.removable = false;
				filters.multiSelectFilters = [
					leanFilterService.filterDefinitions['BusinessUnit'],
					leanFilterService.filterDefinitions['Division'],
					leanFilterService.filterDefinitions['Entity'],
					siteFilter,
					$scope.filterService.filterDefinitions['Item Group'],
					$scope.filterService.filterDefinitions['Supplier'],
					$scope.filterService.filterDefinitions['Buyer'],
					$scope.filterService.filterDefinitions['Planner'],
					$scope.filterService.filterDefinitions['ERP Order Policy'],
					$scope.filterService.filterDefinitions['MaterialGroup'],
					$scope.filterService.filterDefinitions['MaterialType'],
					$scope.filterService.filterDefinitions['TaskStatus'],
					$scope.filterService.filterDefinitions['TaskCategory'],
					$scope.filterService.filterDefinitions['Responsible']
				];
			} else {
				filters.multiSelectFilters = [
					$scope.filterService.filterDefinitions['ERP Order Policy']
				];
			}
			filters = leanFilterService.addFlexFiltersBySourceType(['item'], filters);
			leanFilterService.setAllFilterLists(filters);
		}

		function columns() {
			var cols = [
				{
					id: 'actionStatus', //id field that is used for most jQuery calls in directive. Must be same name as what is contained in the response[0] data object
					display: 'Task Status', //Determines content of column header
					width: 80, // Default width if there is no reportConfig
					renderer: tableRenderService.statusWithCircle, // Column specific renderer applied to each cell defined in tableRenderService.
					show: true, //Defaults to appear on report or not
					enablePinning: true, //Allows column to be pinned
					pinnedLeft: true,
					sort: false,
					title: '' //Determines hoverText
				},
				{
					id: 'itemCode',
					display: 'Item Code',
					width: 150,
					renderer: tableRenderService.itemCode,
					title: '',
					pinnedLeft: true
				},
				{
					id: 'itemGroupName',
					display: 'Item Group',
					width: 150
				},
				{
					id: 'factoryName',
					display: 'Site',
					width: 160,
					title: ''
				},
				{
					id: 'erpOrderPolicy',
					display: 'ERP Order Policy',
					width: 100,
					show: false,
					title: ''
				},
				{
					id: 'supplierName',
					display: 'Supplier',
					width: 220,
					title: ''
				},
				{
					id: 'buyerCode',
					display: 'Buyer',
					width: 140,
					show: false,
					title: ''
				},
				{
					id: 'planner',
					display: 'Planner',
					width: 100,
					show: false,
					title: ''
				},
				{
					id: 'totalOnHandUnrestrictedQuantity',
					display: 'On Hand (Unrestricted)',
					width: 80,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'totalOnHandConsignmentQuantity',
					display: 'Consignment Qty',
					width: 100,
					renderer: tableRenderService.integer,
					show: false
				},
				{
					id: 'safetyStockFloat',
					display: 'Safety Stock',
					width: 100,
					renderer: tableRenderService.integer
				},
				{
					id: 'maxLevelFloat',
					display: 'Max Level',
					width: 100,
					renderer: tableRenderService.integer,
					title: ''
				},
				{
					id: 'overMaxValue',
					display: 'Value Over Max',
					width: 100,
					renderer: tableRenderService.currency,
					sortDefaultReverse: true,
					title: ''
				},
				{
					id: 'currentReOrderPoint',
					display: 'Reorder Point',
					width: 100,
					renderer: tableRenderService.integer
				},
				{
					id: 'currentReOrderQty',
					display: 'Reorder Qty',
					width: 100,
					renderer: tableRenderService.integer
				},
				{
					id: 'analysisSafetyStockLevelFloat',
					display: 'Recommended Safety Stock',
					width: 120,
					renderer: tableRenderService.integer,
					show: false
				},
				{
					id: 'recommendedReorderPointInt',
					display: 'Recommended Reorder Point',
					width: 120,
					renderer: tableRenderService.integer,
					show: false
				},
				{
					id: 'recommendedReorderQtyFloat',
					display: 'Recommended Reorder Qty',
					width: 120,
					renderer: tableRenderService.integer,
					show: false
				},
				{
					id: 'analysisTargetInventoryQty',
					display: 'Target Qty',
					width: 120,
					renderer: tableRenderService.targetQtyRenderer,
					show: false
				},
				{
					id: 'estimatedSavings',
					display: 'Estimated Savings',
					width: 120,
					renderer: tableRenderService.currency,
					show: false
				},
				{
					id: 'weeklyInventoryDelta',
					display: 'Weekly Inventory Change',
					width: 120,
					renderer: tableRenderService.ppvRenderer,
					show: false
				},
				{
					id: 'weeklyOpportunityDelta',
					display: 'Weekly Opportunity Change',
					width: 120,
					renderer: tableRenderService.ppvRenderer,
					show: false
				},
				{
					id: 'next30Days',
					display: 'On Order Next 30 Days',
					width: 120,
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 30
				},
				{
					id: 'next60Days',
					display: 'On Order Next 60 Days',
					width: 120,
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 60
				},
				{
					id: 'next90Days',
					display: 'On Order Next 90 Days',
					width: 120,
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 90
				},
				{
					id: 'totalOnOrderQuantityFloat',
					display: 'On Order Qty',
					width: 80,
					show: false,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'totalOnOrderValue',
					display: 'Total On Order Value',
					width: 80,
					show: false,
					renderer: tableRenderService.onOrderValue
				},
				{
					id: 'costPerItemFloat',
					display: 'Unit Price',
					width: 100,
					renderer: tableRenderService.currency,
					keepAllDecimals: true
				},
				{
					id: 'purchasingUOM',
					display: 'UOM',
					width: 80,
					show: false
				}, {
					id: 'abcClass',
					display: 'ABC Rank',
					width: 80
				},
				{
					id: 'totalOnHandQuantityFloat',
					display: 'Total On Hand Qty',
					width: 100,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'currentOnHandCostFloat',
					display: 'Total On Hand Value',
					width: 100,
					show: false,
					renderer: tableRenderService.currency
				},
				{
					id: 'leadTimeInDaysFloat',
					display: 'Lead Time',
					width: 100,
					renderer: tableRenderService.leadTime
				}];
			cols = cols.concat(columnsService({
				analysisAvgDailyDemandFloat: 1,
				averageDailyDemandFromPastRqmts: 0,
				averageDailyDemandFromFutureRqmts: 0,
				isVmi: 0
			}));
			cols = cols.concat([
				{
					id: 'analysisReplenishmentType',
					display: 'Recommended Policy',
					width: 120,
					show: false
				},
				{
					id: 'productHierarchy',
					display: 'Product Hierarchy',
					width: 120,
					show: false
				},
				{
					id: 'externalMaterialGroup',
					display: 'External Material Group',
					width: 120,
					show: false
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				}
			]);
			if (globalConfig.user.role !== 'Supplier') {
				cols = flexColumns.addFlexColumnsBySourceType(['item'], cols);
			}
			return cols;
		}
		var pinnedColumns = [];

		function getExcelColumns() {
			return columns().concat([{ id: 'daysDisplayType' }]);
		}


		//Defines meta. Important, must be defined last so that all relevant values are set before directive is passed on.
		var meta = {
			reportSettingsName: reportSettingsName, // Used in reportSettings call.
			reportSettingsId: reportSettingsId,
			reportUrl: '{0}/ItemReport/Opportunities/ropItemsOverMax' ,
			noPaging: false, //If false multi, if true single paged report
			columns: columnList, //Passes on columns object
			pinnedColumns: pinnedColumns,
			setColumnDefaults: true,
			defaultSort: 'overMaxValue', // Default Sort Column ID
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			extraParams: extraParams, //Used for any miscellaneous variables used in report specific behavior such as Excel Export
			rendererParams: rendererParams, //Used for report specific rendering
			pageSize: 50, //Determines number of rows per page
			searchType: 'item', // Searchtype sets search box text and more importantly tells directive what search fields to clear in leanFilterService
			excelRequest: true,
			excelReportName: 'Opportunity',
			useReportBuilderForExcel: true,
			hasMandatoryFilters: globalConfig.user.role !== 'Supplier'
		};
		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();
